import { createSelector } from 'reselect';
import _ from 'lodash';
import moment from 'moment';

import { get, post, put, del, } from 'utils/fetch';
import { 
  createAction,
  entity_reducer,
  list_reducer,
  list_remove } from 'utils/store';
import { RequestState } from 'constants/constants';
import { createList, createListSelector, } from 'utils/list';

import { selectApiHost, selectApiToken, selectCurrentAccountId } from 'store/AppState';
import { REMOVE_CHANNEL } from 'store/models/Channel';
import { FETCH_CHANNEL_STREAM_STATS, FETCH_CAMPAIGN_STREAM_STATS } from 'store/models/Stats';


// ======================
// HELPERS
// ======================
export const isSessionRunning = s => {
  return s && s.start && s.streamId && !s.end;

  if(!s)
    return false;

  let lastPing = _.chain(s)
    .get('pings')
    .orderBy('timestamp', 'desc')
    .first()
    .get('timestamp')
    .value();

  let since = moment.duration(moment().diff(moment(lastPing))).asMinutes();
  return !_.isNil(s) && !_.isEmpty(s.created) && _.isEmpty(s.end) && (since < 10);
}


// ======================
// ACTIONS
// ======================
export const SESSION_PING = 'SESSION_PING';
export const FETCH_SESSION = 'FETCH_SESSION';
export const FETCH_SESSIONS = 'FETCH_SESSIONS';


// ======================
// SELECTORS
// ======================
export const selectSessions = state => state.models.sessions;
export const selectSession = (state, sessionId) => state.models.sessions[sessionId];
export const selectOverlaySessions = (state, overlayId) => 
  _.filter(state.models.sessions, s => (s.overlayId === overlayId && s.start && !s.end))
  
export const selectSessionByStreamId = (state, streamId) => state.models.sessions |> _.find(#, { streamId });
export const selectSessionsByStreamIds = createSelector(
  selectSessions,
  (state, streamIds) =>  streamIds,
  (sessions, streamIds) => _.filter(sessions, s => _.includes(streamIds, s?.streamId))
)

export const selectSessionsForChannel = createListSelector('sessionsForChannel');
export const selectSessionsForCampaign = createListSelector('sessionsForCampaign');

export const selectLiveSession = (state, overlayId, channelId) => 
  _.filter(state.models.sessions, s => (s.overlayId === overlayId && s.channelId === channelId && s.start && !s.end))


// ======================
// MODEL
// ======================
const Session = {
  actions: {
    pingSession: (code, streamer, sceneStats, env, refresh ) => {
      return (dispatch, getState) => {
        let url = `/api/session/ping/:code`;
        url = _.isString(streamer) && streamer.length ? url + `/:streamer` : url;
        return post({
          url, 
          params: { code, streamer },
          body: { sceneStats, env },
          dispatch, 
          action: SESSION_PING,
        });
      }
    },

    fetchRunningSessions: accountId => (dispatch, getState) => 
      accountId ?? selectCurrentAccountId(getState())
        |> get({
            url: `/api/account/:accountId/running_sessions`,
            params: { accountId: # },
            dispatch,
            action: FETCH_SESSIONS,
    }),
  },

  spec: { 
    sessions: {},
  },

  reducer: (state, type, body, action, json) => {
    if(action.result !== RequestState.SUCCESS)
      return state;

    if(body && body.sessions) {
      return { 
        ...state, 
        sessions: entity_reducer(state.sessions, body.sessions, '_id')
      };
    }
    switch(type) {
      case REMOVE_CHANNEL:
          return { 
            ...state, 
            sessions: _.filter(state.sessions, { channelId: body._id }) };
    }
    return state;
  },

  listSpec: {
    sessionsForChannel: {},
    sessionsForCampaign: {},
  },

  listReducer: (state, type, body, action, json) => {
    if(action.url && action.result !== RequestState.SUCCESS)
      return state;

    switch(type) {
      case FETCH_CHANNEL_STREAM_STATS:
        return { ...state,
          sessionsForChannel: {
            ...state.sessionsForChannel,
            [action.params.channelId]: createList(body.sessions, 'sessions', '_id')
          } 
        }
      case FETCH_CAMPAIGN_STREAM_STATS:
        return { ...state,
          sessionsForCampaign: {
            ...state.sessionsForCampaign,
            [action.params.campaignId]: createList(body.sessions, 'sessions', '_id')
          } 
        }
    }
    return state;
  }
}
export default Session;
